import React from 'react';
import { IndicatorBadgeDot } from './IndicatorBadgeDot';
import { IndicatorBadgeIcon } from './IndicatorBadgeIcon';
import MuiBadge from '@mui/material/Badge';
import { IndicatorBadgeTick } from './IndicatorBadgeTick';
import { IndicatorBadgeImage } from './IndicatorBadgeImage';
import { styled } from '@mui/material/styles';
import { jsx as _jsx } from "react/jsx-runtime";
export function IndicatorBadge(props) {
  var _IndicatorBadgeIcon, _IndicatorBadgeImage, _IndicatorBadgeTick, _IndicatorBadgeDot;
  var Icon = props.Icon,
    children = props.children,
    _props$dotIntent = props.dotIntent,
    dotIntent = _props$dotIntent === void 0 ? 'primary' : _props$dotIntent,
    _props$iconIntent = props.iconIntent,
    iconIntent = _props$iconIntent === void 0 ? 'primary' : _props$iconIntent,
    imageAltText = props.imageAltText,
    imageSrc = props.imageSrc,
    _props$size = props.size,
    size = _props$size === void 0 ? 'xs' : _props$size,
    sx = props.sx,
    _props$type = props.type,
    type = _props$type === void 0 ? 'dot' : _props$type;
  var StyledBadge = styled(MuiBadge)(function () {
    return {
      height: badgeSize[size].size,
      sx: sx,
      width: badgeSize[size].size
    };
  });
  var badgeSize = {
    '2xl': {
      size: 64
    },
    lg: {
      size: 48
    },
    md: {
      size: 40
    },
    sm: {
      size: 32
    },
    xl: {
      size: 56
    },
    xs: {
      size: 24
    }
  };
  switch (type) {
    case 'icon':
      return /*#__PURE__*/_jsx(StyledBadge, {
        anchorOrigin: {
          horizontal: 'right',
          vertical: 'bottom'
        },
        badgeContent: _IndicatorBadgeIcon || (_IndicatorBadgeIcon = /*#__PURE__*/_jsx(IndicatorBadgeIcon, {
          Icon: Icon,
          intent: iconIntent,
          size: size
        })),
        overlap: "circular",
        children: children
      });
    case 'image':
      return /*#__PURE__*/_jsx(StyledBadge, {
        anchorOrigin: {
          horizontal: 'right',
          vertical: 'bottom'
        },
        badgeContent: _IndicatorBadgeImage || (_IndicatorBadgeImage = /*#__PURE__*/_jsx(IndicatorBadgeImage, {
          imageAltText: imageAltText,
          imageSrc: imageSrc,
          size: size
        })),
        overlap: "circular",
        children: children
      });
    case 'verified':
      return /*#__PURE__*/_jsx(StyledBadge, {
        anchorOrigin: {
          horizontal: 'right',
          vertical: 'bottom'
        },
        badgeContent: _IndicatorBadgeTick || (_IndicatorBadgeTick = /*#__PURE__*/_jsx(IndicatorBadgeTick, {
          size: size
        })),
        overlap: "circular",
        children: children
      });
    case 'dot':
    default:
      return /*#__PURE__*/_jsx(StyledBadge, {
        anchorOrigin: {
          horizontal: 'right',
          vertical: 'bottom'
        },
        badgeContent: _IndicatorBadgeDot || (_IndicatorBadgeDot = /*#__PURE__*/_jsx(IndicatorBadgeDot, {
          intent: dotIntent,
          size: size
        })),
        overlap: "circular",
        children: children
      });
  }
}